import Url from './Url'
import Config from '../Config'
let { ApiGet, ApiPost, Language, ToastTip, ModalTip, format, getImageSize, GLOBAL, locale, platform } = Config()
const { ModalInfo } = ModalTip
import { ProgressStatusFun, CustomerText } from '../CustomerText'
import moment from 'moment'
const ProgressStatus = ProgressStatusFun(Language)
let tempText = CustomerText[Language]
const Timezone = {
    M1: 8,
    M2: 7,
    M3: 7
}
let recordData = [
    {
        'questionType': '存款问题',
        'status': 0,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolor …….',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00'
    },
    {
        'questionType': '存款问题',
        'status': 1,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolorw eqweo qigyeq woegu iqkwe hoqguwelq hw eugqkwl hsdfskhdfs gdfuiwe grwukergwey kqweqeqe qeqeqw qeqwqweruwegrulwrwelryuweyrgwegrlwrwyerwrywgrwyrwgirgweriwgerw.',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00',

    },
    {
        'questionType': '存款问题',
        'status': 2,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolor …….',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00'
    },
    {
        'questionType': '存款问题',
        'status': 3,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolor …….',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00'
    },
    {
        'questionType': '存款问题',
        'status': 4,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolor …….',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00'
    },
    {
        'questionType': '存款问题',
        'status': 5,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolor …….',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00'
    },
    {
        'questionType': '存款问题',
        'status': 6,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolor …….',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00'
    },
    {
        'questionType': '存款问题',
        'status': 4,
        'caseNumber': '12345678',
        'description': 'Lorem ipsum dolor …….',
        'dateCreated': '2023-11-06T14:21:00',
        'dateClosed': '2023-11-07T14:21:00'
    },
]

let temp = [
    {
        "categoryName": "Test Category I",
        "articles": [
            {
                "knowledgeBaseID": "kr01m000000I2htKRI",
                "articleNumber": "00001971",
                "title": "User First Special Bonus"
            },
            {
                "knowledgeBaseID": "ss01m000000G5hmGRJ",
                "articleNumber": "00001975",
                "title": "Group Applicable Special Bonus"
            },
            {
                "knowledgeBaseID": "CliffTesting123",
                "articleNumber": "000004341",
                "title": "【F1M1】Deposit - What is USDT 什么是泰达币"
            }
        ]
    },
    {
        "categoryName": "Test Category V",
        "articles": [
            {
                "knowledgeBaseID": "kr01m000000I2htKRI",
                "articleNumber": "00001971",
                "title": "User First Special Bonus"
            },
            {
                "knowledgeBaseID": "ss01m000000G5hmGRJ",
                "articleNumber": "00001975",
                "title": "Group Applicable Special Bonus"
            },
            {
                "knowledgeBaseID": "CliffTesting123",
                "articleNumber": "000004341",
                "title": "【F1M1】Deposit - What is USDT 什么是泰达币"
            }
        ]
    },
    {
        "categoryName": "F1",
        "articles": [
            {
                "knowledgeBaseID": "kr01m000000I2htKRI",
                "articleNumber": "00001971",
                "title": "User First Special Bonus"
            },
            {
                "knowledgeBaseID": "ss01m000000G5hmGRJ",
                "articleNumber": "00001975",
                "title": "Group Applicable Special Bonus"
            },
            {
                "knowledgeBaseID": "CliffTesting123",
                "articleNumber": "000004341",
                "title": "【F1M1】Deposit - What is USDT 什么是泰达币"
            }
        ]
    }
]

export async function GetCategories(flag) {
    //!flag && ToastTip.loading(tempText?.text70)
    try {
        let res = await ApiGet(Url.Categories)
        //ToastTip.hide()
        if (res.isSuccess) {
            let result = res?.result || []
            result.forEach(v1 => {
                Array.isArray(v1.articles) && v1.articles.forEach(v2 => {
                    v2.content = ''
                    v2.isShow = false
                })
            })
            return result
        } else {
            return []
        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        return []
    }
}


export async function GetDetail({ knowledgeBaseID }) {
    ToastTip.loading(tempText?.text70)
    try {
        let res = await ApiGet(Url.Detail + knowledgeBaseID + '?serviceType=1&')
        ToastTip.hide()
        if (res.isSuccess) {
            return res.result
        } else {

        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
    }
}



export async function GetQuestionTypes(flag) {
    //!flag && ToastTip.loading(tempText?.text70)
    try {
        let res = await ApiGet(Url.QuestionTypes)
        //ToastTip.hide()
        if (res.isSuccess) {
            return res.result
        } else {
            return []
        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        return []
    }
}


export async function GetHotTopics(flag) {
    // !flag && ToastTip.loading(tempText?.text70)
    try {
        let res = await ApiGet(Url.HotTopics)
        //ToastTip.hide()
        if (res.isSuccess) {
            return res.result
        } else {
            return []
        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        return []
    }
}


export async function GetRecordData({ dateFrom, dateTo, status, category }) {
    ToastTip.loading(tempText?.text70)
    try {
        let res = await ApiGet(Url.Case + `dateFrom=${dateFrom}&dateTo=${dateTo}&status=${status}&category=${category}&serviceType=1&`)
        ToastTip.hide()
        let { isSuccess, result } = res
        if (isSuccess) {
            if (Array.isArray(result) && result.length) {
                let dateCreatedArr = [...new Set(result.map(v => v.dateCreated))]
                let resultFina = dateCreatedArr.map(v1 => {
                    let tempArr = result.filter(v2 => v2.dateCreated == v1)
                    let tempSignedURLArr = (tempArr.length && tempArr[0]?.signedURL) ? tempArr.map(v2 => ({
                        signedURL: v2?.signedURL,
                        objectKey: v2?.objectKey
                    })) : []
                    tempArr[0].signedURLArr = tempSignedURLArr
                    return tempArr[0]
                })
                let timeZone = Timezone[Language]
                for (let i1 = 0; i1 < resultFina.length; i1++) {
                    let v = resultFina[i1]
                    let { color = 'transparent', text = '' } = ProgressStatus[v.status] || {}
                    v.color = color
                    v.text = text
                    // // 使用 toLocaleString() 方法将时间转换为本地时间
                    v.dateCreated = moment.utc(v?.dateCreated).utcOffset(timeZone * 60).format(format)
                    delete v?.signedURL
                    delete v?.objectKey
                    if (v?.dateClosed) {
                        v.dateClosed = moment.utc(v?.dateClosed).utcOffset(timeZone * 60).format(format)
                    }
                    let signedURLArr = []
                    let tempSignedURLArr = v?.signedURLArr
                    if (tempSignedURLArr?.length > 0) {
                        for (let i2 = 0; i2 < tempSignedURLArr.length; i2++) {
                            let layout = await getImageSize(tempSignedURLArr[i2]?.signedURL) || { width: 200, height: 200 }
                            signedURLArr[i2] = {
                                uri: tempSignedURLArr[i2]?.signedURL,
                                layout,
                                name: tempSignedURLArr[i2]?.objectKey
                            }
                        }
                    }
                    // v.signedURLArr = [
                    //     {
                    //         uri: 'https://cmsapistag.fun88.biz/uploads/4_BSG_0_c1e2a18c75.webp',
                    //         layout: {
                    //             width: 200, height: 200 
                    //         },
                    //         name: '123123'
                    //     },
                    //     {
                    //         uri: 'https://cmsapistag.fun88.biz/uploads/4_BSG_0_c1e2a18c75.webp',
                    //         layout: {
                    //             width: 200, height: 200 
                    //         },
                    //         name: '123123'
                    //     },
                    //     {
                    //         uri: 'https://cmsapistag.fun88.biz/uploads/4_BSG_0_c1e2a18c75.webp',
                    //         layout: {
                    //             width: 200, height: 200 
                    //         },
                    //         name: '123123'
                    //     },
                    // ]
                }
                // resultFina.forEach(v => {
                //     v.isOpenDes = false
                // })
                return resultFina
            } else {
                return []
            }
        } else {
            // ModalInfo({
            //     text1: tempText.text72,
            //     text2: tempText.text67,
            // })
            return []
        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        // ModalInfo({
        //     text1: tempText.text72,
        //     text2: tempText.text67,
        // })
        return []
    }


}

export async function GetPresignedUrl(params) {
    ToastTip.loading(tempText?.text70)
    let res = await ApiPost(Url.PresignedUrl, params)
    try {
        ToastTip.hide()
        if (res.isSuccess) {
            return res.result
        } else {
            return []
        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        return []
    }
}


export async function GetSearchTerm(searchTerm) {
    try {
        let res = await ApiGet(Url.SearchTerm + 'searchTerm=' + searchTerm + '&')
        if (res.isSuccess) {
            return res.result
        } else {
            return {
                'searchCount': 0,
                'searchResult': []
            }
        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        return {
            'searchCount': 0,
            'searchResult': []
        }
    }
}


export async function PostCase(params) {
    ToastTip.loading(tempText?.text70)
    try {
        let res = await ApiPost(Url.PostCase, params)
        ToastTip.hide()
        if (res.isSuccess) {
            ToastTip.success(tempText?.text73)
            return true
        } else {
            ToastTip.error(tempText?.text71)
            return false
        }
    } catch (err) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        return false
    }
}



export async function GetAISearch({ text = '' }) {
    try {
        
        ToastTip.loading(tempText?.text70);

        let res = await ApiGet(Url.GloqoSearch + 'title=' + text + '&')

        ToastTip.hide()
        let { isSuccess = false, result = {} } = res
        if (!isSuccess) {
            ToastTip.error(tempText.text72)
            return ''
        }
  
        let { Result = '', Content = {}, ResponseCode = '' } = result
        let { response = '' } = Content

        if (ResponseCode == 'GEN99999') {
            ToastTip.error(tempText.text72)
            return ''
        }

        if (Result == 'Success') {
            return (response.includes('没有找到') || response.includes('无法提供') || response.includes('ฉันไม่สามารถ') || response.includes('ไม่พบ') || response.includes('không') || response.includes('rất tiếc') || response.includes('ไม่มี')) ? '' : response
        }
    } catch (error) {
        ToastTip.hide();
        ToastTip.error(tempText.text72)
        return { error: 'Something went wrong' };
    }
}
